import Head from "next/head";
import React from "react";

import TabsMenu from "components/global/TabsMenu/TabsMenu";
import ProfileStores from "components/profileStores/ProfileStores/ProfileStores";
import CONSTANTS from "config/constants";

const { TITLE } = CONSTANTS;

interface Props {}

const StoresPage = (props: Props) => {
  return (
    <>
      <Head>
        <title>Locales | {TITLE}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <TabsMenu>
        <ProfileStores />
      </TabsMenu>
    </>
  );
};

export default StoresPage;
